import React from 'react';
import PropTypes from "prop-types";

export function CsfPivotalFournisseurGestionFormateursStep5Table({
  trainers,
  handleModalClick,
  handleDeleteId,
  trashAllTrainers,
  isTrainersUndetermined,
  handleChangeCheck,
  isIQPF,
  isELearning
}) {

  return (
    <div className="table-wrapper table-step05">
      <form id="form-step05table">
        <table id="formateur-list-table">
          <caption id="formateur-list-caption"
            className="sr-only">{window.Drupal.t('fournisseur.trainers.listing.table.title')}</caption>
          <thead>
            <tr>
              <th width="20%">
                {window.Drupal.t('fournisseur.gestion.table.firstname')}
              </th>
              <th width="28%">
                {window.Drupal.t('fournisseur.gestion.table.lastname')}
              </th>
              <th width="12%">
                {window.Drupal.t('fournisseur.gestion.status.label')}
              </th>

              {isIQPF && (
                <th>
                  {window.Drupal.t('fournisseur.gestion.table.financial_institut_matricule')}
                </th>
              )}

              <th>{window.Drupal.t('fournisseur.gestion.table.email')}</th>
              <th width="50">
                {trainers.length > 0 && (
                  <button onClick={trashAllTrainers} type="button"
                    data-toggle="modal" data-target="#deleteModal"
                    className='button btn-outlined btn-icon-only'>
                    <span className="icon-trash-can supplier-icon"><span
                      className="d-none">&nbsp;</span></span>
                  </button>
                )}
              </th>
            </tr>
          </thead>
          <tbody>

            {trainers.length === 0 ? (
              <tr>
                <td colSpan="6">
                  <div id="emptyList">
                    <div className="form-group d-flex">
                      <input id="chkConfirmNoTrainer" name="chkConfirmNoTrainer" type="checkbox"
                        checked={isTrainersUndetermined} onChange={handleChangeCheck} />
                      {isELearning ?
                        (<label htmlFor="chkConfirmNoTrainer">
                          {window.Drupal.t('fournisseur.step5.e_learning_no_trainers.label')}
                        </label>) :
                        (<label htmlFor="chkConfirmNoTrainer">
                          <p>{window.Drupal.t('fournisseur.step5.comfirm_no_trainer.label')}</p>
                          <p>{window.Drupal.t('fournisseur.step5.comfirm_no_trainer.attention')}</p>
                        </label>)
                      }
                    </div>
                  </div>
                </td>
              </tr>
            ) : (
              trainers.map((item) => (
                <tr key={item.Contact_Id}>
                  <td>{item.First_Name}</td>
                  <td>{item.Last_Name}</td>
                  <td>{item.Contact_Status}</td>
                  {isIQPF && (
                    <td>
                      {item.IPF_Matricule_Bridge ? item.IPF_Matricule_Bridge : <>
                        <input type="text" name="matricule" className="matricule-missing-input"
                          style={{ height: '25px', width: '130px' }} readOnly disabled />
                      </>}
                    </td>
                  )}
                  <td>{item.Contact_Email}</td>
                  <td>
                    <button type="button" className='button btn-outlined btn-icon-only'
                      onClick={() => handleDeleteId(item.Contact_Id)}
                      data-toggle="modal" data-target="#deleteModal"
                      title={window.Drupal.t('Delete')}>
                      <span className="icon-remove supplier-icon"><span
                        className="d-none">&nbsp;</span></span>
                    </button>
                  </td>
                </tr>
              )))}
          </tbody>
        </table>

      </form>
    </div>
  );
}

CsfPivotalFournisseurGestionFormateursStep5Table.propTypes = {
  trainers: PropTypes.array,
  handleModalClick: PropTypes.func,
  handleDeleteId: PropTypes.func,
  trashAllTrainers: PropTypes.func,
  isTrainersUndetermined: PropTypes.bool,
  onIsTrainerUndeterminedChange: PropTypes.func,
  isIQPF: PropTypes.bool
};
